import React, { Component } from "react";

import { Form, Button, Col, Row, Input, Alert, Select } from "antd";

import SizeType from "../../../../helpers/deviceTypeSize";

const { TextArea } = Input;
const { Option } = Select;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

class CategoryForm extends Component {
  state = {
    sameTypeErrorVisbile: false,
    alertSuccessVisible: false,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err && !this.isExsitsType()) {
        this.props.saveType(values, this.showSuccess.bind(this));
      }
    });
  };

  isExsitsType = () => {
    const check = this.props.types.find(
      (item) => item.name === this.props.form.getFieldValue("name")
    );
    if (check !== undefined && check !== -1) {
      this.setState({ sameTypeErrorVisbile: true });
      return true;
    } else {
      this.setState({ sameTypeErrorVisbile: false });
      return false;
    }
  };

  showSuccess = () => {
    this.setState({ alertSuccessVisible: true });
    this.props.form.resetFields();
    setTimeout(() => {
      this.setState({ alertSuccessVisible: false });
    }, 3000);
  };

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;

    const alert = (
      <Alert
        style={{ marginBottom: "10px", zIndex: "1" }}
        message="Dogodila se greša"
        description="Dogodila se greška prilikom spremanja na server molimo vas probajte ponovo!"
        type="error"
      />
    );

    const alertSuccess = (
      <Alert
        style={{ marginBottom: "10px", zIndex: "1" }}
        message="Uspješno"
        description="Uspješno ste dodali kategoriju!"
        type="success"
      />
    );

    const alertSameType = (
      <Alert
        style={{ marginBottom: "10px", zIndex: "1" }}
        message="Dogodila se greša"
        description="Kategorija već postoji!"
        type="error"
      />
    );

    const formItemLayout = {
      labelCol: {
        span: 6,
      },
      wrapperCol:
        SizeType() === "xs" || SizeType() === "sm"
          ? {
              xs: {
                span: 24,
                offset: 0,
              },
              sm: {
                span: 16,
                offset: 0,
              },
            }
          : {
              span: 18,
              offset: 0,
            },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 24,
          offset: 0,
        },
      },
    };

    const layoutType =
      SizeType() === "xs" || SizeType() === "sm" ? "vertical" : "horizontal";


    const { type } = this.props;

    return (
      <React.Fragment>
        {this.state.alertSuccessVisible ? alertSuccess : null}
        {this.state.sameTypeErrorVisbile ? alertSameType : null}
        {type.status === "error" ? alert : null}
        <Form
          {...formItemLayout}
          layout={layoutType}
          hideRequiredMark
          onSubmit={this.handleSubmit}
        >
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label={"Tip:"}>
                {getFieldDecorator("name", {
                  initialValue: null,
                  rules: [
                    { required: true, message: "Unesite tekst!" },
                    { min: 3, message: "Minimalno znakova 3!" },
                  ],
                })(<TextArea />)}
              </Form.Item>
              <Form.Item {...tailFormItemLayout}>
                <Button
                  style={{ float: "right" }}
                  loading={type.status === "loading"}
                  type="primary"
                  htmlType="submit"
                  disabled={hasErrors(getFieldsError())}
                >
                  Spremi
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </React.Fragment>
    );
  }
}

export default Form.create()(CategoryForm);
